import * as React from 'react';
import { Button } from '@cian/ui-kit';

interface IProps {
  isPending: boolean;
  handleButtonClick(): void;
}

export const SelfMoneySourceButton = ({ isPending, handleButtonClick }: IProps) => (
  <Button type="button" theme="fill_primary" onClick={handleButtonClick} loading={isPending} fullWidth>
    Переключиться на личный счёт
  </Button>
);
